'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = require('../internal/ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Button', function (theme) {
  var typography = theme.typography,
      palette = theme.palette,
      transitions = theme.transitions,
      shadows = theme.shadows;

  return {
    root: Object.assign({}, typography.body1, theme.mixins.gutters(2), {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: typography.rhythmByUnit(11),
      height: typography.rhythmByUnit(4),
      borderRadius: theme.variables.buttonBorderRadius,
      backgroundColor: 'transparent',
      transition: transitions.create(['background-color', 'box-shadow'], {
        duration: transitions.duration.short
      }),
      '&:hover, &:focus': {
        textDecoration: 'none',
        backgroundColor: palette.grey[50],
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    primary: {
      color: palette.primary[500]
    },
    accent: {
      color: palette.accent[500]
    },
    active: {
      // this space intentionally blank, for now
    },
    contrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    raised: {
      color: palette.getContrastText(palette.grey[300]),
      backgroundColor: palette.background.paper,
      borderColor: palette.grey[100],
      borderStyle: 'solid',
      borderWidth: 1,
      '&$disabled': {
        backgroundColor: palette.grey[200],
        borderColor: palette.grey[300]
      },
      '&:hover, &:focus': {
        backgroundColor: palette.grey.A100,
        borderColor: palette.grey[200],
        '&$disabled': {
          backgroundColor: palette.text.divider
        }
      }
    },
    keyboardFocused: {},
    raisedPrimary: {
      color: palette.getContrastText(palette.primary[500]),
      fontWeight: typography.fontWeightMedium,
      backgroundColor: palette.success[500],
      '&:hover, &:focus': {
        backgroundColor: palette.success[600]
      },
      border: 'none'
    },
    raisedContrast: {
      color: palette.getContrastText(palette.primary[500])
    },
    disabled: {
      color: palette.action.disabled,
      cursor: 'not-allowed'
    },
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: typography.rhythmByUnit(7),
      height: typography.rhythmByUnit(7),
      border: 'none',
      boxShadow: shadows[6],
      /* Internet Explorer 10+ */
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        transform: 'translate3d(0, 0, 0)' // Hardware-Accelerated CSS
      },
      '&:active': {
        boxShadow: shadows[12]
      }
    },
    fabPrimary: {
      color: palette.getContrastText(palette.primary[500]),
      backgroundColor: palette.primary[500],
      '&:hover, &:focus': {
        backgroundColor: palette.primary[600]
      }
    },
    colorInherit: {
      color: 'inherit',
      '&:hover, &:focus': {
        color: 'initial'
      }
    },
    fullWidth: {
      display: 'flex',
      width: '100%'
    },
    compact: Object.assign({}, theme.mixins.gutters(1), {
      minWidth: typography.rhythmByUnit(8)
    })
  };
});

/**
 * Buttons communicate the action that will occur when the user
 * touches them.
 *
 * ```jsx
 * <Button>Hello World</Button>
 * ```
 */
var Button = (_temp2 = _class = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.isDisabled = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          disabled = _this$props.disabled;

      return typeof disabled === 'boolean' ? disabled : type === 'submit' && _this.hasErrors();
    }, _this.hasErrors = function () {
      var _this$context$muiForm = _this.context.muiForm;
      _this$context$muiForm = _this$context$muiForm === undefined ? {} : _this$context$muiForm;
      var _this$context$muiForm2 = _this$context$muiForm.hasErrors,
          hasErrors = _this$context$muiForm2 === undefined ? function () {
        return false;
      } : _this$context$muiForm2;

      return hasErrors();
    }, _this.handleClick = function (event) {
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;


      if (_this.isDisabled()) {
        return event && event.preventDefault();
      }

      return onClick(event); // eslint-disable-line flowtype-errors/show-errors
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props = this.props,
            accent = _props.accent,
            active = _props.active,
            children = _props.children,
            classNameProp = _props.className,
            colorInherit = _props.colorInherit,
            compact = _props.compact,
            contrast = _props.contrast,
            disabledProp = _props.disabled,
            fab = _props.fab,
            fullWidth = _props.fullWidth,
            onClick = _props.onClick,
            primary = _props.primary,
            raised = _props.raised,
            other = _objectWithoutProperties(_props, ['accent', 'active', 'children', 'className', 'colorInherit', 'compact', 'contrast', 'disabled', 'fab', 'fullWidth', 'onClick', 'primary', 'raised']);

        var disabled = this.isDisabled();
        var classes = this.context.styleManager.render(styleSheet);
        var flat = !raised && !fab;
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.active, active), _defineProperty(_classNames, classes.raised, raised || fab), _defineProperty(_classNames, classes.fab, fab), _defineProperty(_classNames, classes.primary, flat && primary), _defineProperty(_classNames, classes.accent, flat && accent), _defineProperty(_classNames, classes.contrast, flat && contrast), _defineProperty(_classNames, classes.raisedPrimary, !flat && (primary || accent)), _defineProperty(_classNames, classes.fabPrimary, fab && primary), _defineProperty(_classNames, classes.raisedContrast, !flat && contrast), _defineProperty(_classNames, classes.compact, compact), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.colorInherit, flat && colorInherit), _classNames), classNameProp);

        var fullTypeOf = other['typeof'] ? 'ui:Button ' + other['typeof'] : 'ui:Button';

        return _react2['default'].createElement(
          _ButtonBase2['default'],
          _extends({
            className: className,
            disabled: disabled,
            keyboardFocusedClassName: classes.keyboardFocused
          }, other, {
            onClick: this.handleClick,
            tabIndex: disabled ? '-1' : undefined,
            'typeof': fullTypeOf
          }),
          _react2['default'].createElement(
            'span',
            { className: classes.label },
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Button;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the button will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will appear to be selected.
   */
  active: _PropTypes2['default'].bool,
  /**
   * The content of the button.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * Uses a smaller minWidth, ideal for things like card actions.
   */
  compact: _PropTypes2['default'].bool,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If true, will use the theme's contrast color.
   */
  contrast: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, will use floating action button styling.
   */
  fab: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will have a keyboard focus ripple.
   * Ripple must also be true.
   */
  focusRipple: _PropTypes2['default'].bool,
  /**
   * If `true`, button will be expanded to full width
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * The URL to link to when the button is clicked.
   * If set, an `a` element will be used as the root node.
   */
  href: _PropTypes2['default'].string,
  /**
   * @ignore
   */
  onClick: _PropTypes2['default'].func,
  /**
   * If `true`, the button will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will use raised styling.
   */
  raised: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will have a ripple.
   */
  ripple: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  type: _PropTypes2['default'].string,
  /**
   * The type of the element, appended to the control's own Button type identifier
   */
  'typeof': _PropTypes2['default'].string
}, _class.defaultProps = {
  accent: false,
  colorInherit: false,
  component: 'button',
  compact: false,
  contrast: false,
  disabled: false,
  fab: false,
  focusRipple: false,
  fullWidth: false,
  primary: false,
  raised: false,
  ripple: false,
  type: 'button'
}, _class.contextTypes = {
  muiForm: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Button;


Button.displayName = 'Button';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Button/Button.js
// module id = 1637
// module chunks = 32